import { render, staticRenderFns } from "./TgUserFullName.vue?vue&type=template&id=b5e6103e"
import script from "./TgUserFullName.vue?vue&type=script&lang=js"
export * from "./TgUserFullName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports